import { t } from '../i18n';

// All player-facing Sit out copy. Swap strings in locale files — do not
// hardcode them in components. Seat visuals (dashed Away) stay.

export const SIT_OUT_COPY = {
  get menuRow() { return t('sitOut.menuRow'); },
  get confirmTitle() { return t('sitOut.confirmTitle'); },
  get confirmBody() { return t('sitOut.confirmBody'); },
  get confirmLiveLine() { return t('sitOut.confirmLiveLine'); },
  get confirmBlindsSkip() { return t('sitOut.confirmBlindsSkip'); },
  get confirmBlindsPay() { return t('sitOut.confirmBlindsPay'); },
  get confirmConfirm() { return t('sitOut.confirmConfirm'); },
  get confirmCancel() { return t('common.cancel'); },
  get seatLabel() { return t('sitOut.seatLabel'); },
  get seatLabelShort() { return t('sitOut.seatLabelShort'); },
  get seatLabelPending() { return t('sitOut.seatLabelPending'); },
  get statusTail() { return t('sitOut.statusTail'); },
  get statusTailPending() { return t('sitOut.statusTailPending'); },
  postingMissedBlinds(formatted) { return t('sitOut.postingMissed', { amount: formatted }); },
  get returnButton() { return t('sitOut.returnButton'); },
  get returnHint() { return t('sitOut.returnHint'); },
  get returnHintPending() { return t('sitOut.returnHintPending'); },
  get waitingToDeal() { return t('sitOut.waitingToDeal'); },
  get toggleLabel() { return t('sitOut.toggleLabel'); },
};

export function awaySeatLabel({ dense = false } = {}) {
  return dense ? SIT_OUT_COPY.seatLabelShort : SIT_OUT_COPY.seatLabel;
}

export function pendingSeatLabel() {
  return SIT_OUT_COPY.seatLabelPending;
}

export function sitOutBlindsConfirmLine(payBlinds) {
  return payBlinds ? SIT_OUT_COPY.confirmBlindsPay : SIT_OUT_COPY.confirmBlindsSkip;
}

/** Role-slot label for Away / pending / Next-hand seats. */
export function seatStatusLabel(kind, { dense = false, micro = false } = {}) {
  const short = dense || micro;
  if (kind === 'pending') {
    return short ? SIT_OUT_COPY.seatLabel : SIT_OUT_COPY.seatLabelPending;
  }
  if (kind === 'away') {
    return awaySeatLabel({ dense: short });
  }
  if (kind === 'next') {
    if (micro) return t('sitOut.next');
    if (dense) return t('sitOut.next');
    return t('sitOut.nextHand');
  }
  return null;
}
